import { getActiveZones } from "./index23.js";
import { getActiveBuildings } from "./index24.js";
import { getDynamicDataset } from "./index32.js";
import { CalcAnatomyCores } from "./index171.js";
const pipeCalcAnatomyCores = ([parent, { buildingIds, aggProps }]) => {
	const zones = getActiveZones(parent, aggProps);
	for (const zone of zones) {
		const dynamicDataset = getDynamicDataset(aggProps, zone);
		const buildings = getActiveBuildings(zone, aggProps);
		for (const building of buildings) {
			if (buildingIds && !buildingIds.includes(building.uuid)) continue;
			CalcAnatomyCores(building.data.anatomy, dynamicDataset);
		}
	}
	return [parent, void 0];
};
export { pipeCalcAnatomyCores };

//# sourceMappingURL=index172.js.map